import { Component, Input } from "@angular/core";
import { ReportDesignerItemSpacer } from "../../report-design-item";

@Component({
  selector: "snt-report-form-renderer-spacer",
  templateUrl: "report-form-renderer-spacer.component.html",
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererSpacerComponent {
  @Input() item!: ReportDesignerItemSpacer;
  @Input() level!: number;
  @Input() parentName!: string;

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "spacer",
      config: {
        size: this.item.config.size,
        separator: this.item.config.separator || false
      }
    };
  }
}
